module.exports = __webpack_public_path__ + "img/pic_head portrait_com@2x.7efea17c.png";